import debounce from "lodash-es/debounce";
import PlanType from './app/enums/PlanType';
import { isProduction, route, __v } from './app/support/helpers';
import { internationalize, isEmail, isPhoneNumber, ready } from './app/support/utils';

declare global {
    interface Window {
        lottie: any,
        mainLoaderParams: any
    }
}

ready(function () {

    let $firstname     = $('#firstname');
    let $lastname      = $('#lastname');
    let $city          = $('#city');
    let $mobile        = $('#mobile');
    let $speciality    = $('#speciality');
    let $email         = $('#email');
    let $terms         = $('#terms');
    let $privacy       = $('#privacy');
    let $form          = $('#registerForm');
    let $plan          = $form.find('input[name=plan]');
    let $loader        = $('#mainLoader');
    let $submitButton  = $('#submitRegisterForm');
    let $jsAlert       = $('#jsAlert');
    let $sAlert        = $('#sAlert');
    let $sAlertContent = $sAlert.find('.alertContent');
    let mainLoaderAnimation;


    $('#registrationModal').on('hidden.bs.modal', function () {
        $sAlert.addClass('hidden');
        resetInputsLook();
    });


    $form.on('submit', function (event) {
        event.preventDefault();

        let firstname     = ($firstname.val() as string).trim();
        let lastname      = ($lastname.val() as string).trim();
        let city          = ($city.val() as string).trim();
        let mobile        = ($mobile.val() as string).trim();
        let speciality    = ($speciality.val() as string).trim();
        let email         = ($email.val() as string).trim();
        let plan          = ($plan.val() as string).trim() as PlanType;
        let termsAccepted = $terms.is(':checked');
        let privacyAccepted = $privacy.is(':checked');

        let errors       = [];

        if (!firstname) {
            errors.push(__v('required', 'firstname'));
            $firstname.addClass('is-invalid');
        } else {
            $firstname.removeClass('is-invalid');
        }

        if (!lastname) {
            errors.push(__v('required', 'lastname'));
            $lastname.addClass('is-invalid');
        } else {
            $lastname.removeClass('is-invalid');
        }

        if (!city) {
            errors.push(__v('required', 'city'));
            $city.parents('.bootstrap-select').addClass('is-invalid');
        }
        else {
            $city.parents('.bootstrap-select').removeClass('is-invalid');
        }

        if (!mobile) {
            errors.push(__v('required', 'mobile'));
            $mobile.addClass('is-invalid');
        }
        else if (!isPhoneNumber(mobile)) {
            errors.push(__v('invalid.phone_number'));
            $mobile.addClass('is-invalid');
        }
        else {
            $mobile.removeClass('is-invalid');
        }

        if (!speciality) {
            errors.push(__v('required', 'speciality'));
            $speciality.parents('.bootstrap-select').addClass('is-invalid');
        } else {
            $speciality.parents('.bootstrap-select').removeClass('is-invalid');
        }

        if (!email) {
            errors.push(__v('required', 'email'));
            $email.addClass('is-invalid');
        } else if (!isEmail(email)) {
            errors.push(__v('email', 'email'));
            $email.addClass('is-invalid');
        } else {
            $email.removeClass('is-invalid');
        }

        if (!termsAccepted) {
            errors.push(__v('required', 'terms'));
            $terms.addClass('is-invalid');
        } else {
            $terms.removeClass('is-invalid');
        }

        if (!privacyAccepted) {
            errors.push(__v('required', 'privacy'));
            $privacy.addClass('is-invalid');
        } else {
            $privacy.removeClass('is-invalid');
        }

        if (errors.length) {
            $jsAlert.removeClass('hidden').addClass('danger').html(errors[0]);
            return false;
        }

        if (Object.values(PlanType).indexOf(plan) === -1) {
            $plan.val(PlanType.BASIC);
        }

        $jsAlert.addClass('hidden');

        sendPractitionerRegistration();

        return false;
    });

    /**
     * Send practitioner data
     *
     * @return {void}
     */
    function sendPractitionerRegistration() {
        $.ajax({
            url: route('practitioner.register'),
            type: 'POST',
            dataType: 'json',
            data: {
                firstname   : ($('#firstname').val() as string).trim(),
                lastname    : ($('#lastname').val() as string).trim(),
                city        : ($('#city').val() as string).trim(),
                mobile      : internationalize(($('#mobile').val() as string).trim()),
                dial_code   : '+212', // because only moroccan phone numbers are the accepted ones.
                specialities: [($('#speciality').val() as string).trim()],
                email       : ($('#email').val() as string).trim(),
                terms       : $('#terms').is(':checked') ? 'on' : null,
                privacy     : $('#privacy').is(':checked') ? 'on' : null,
                plan        : ($plan.val() as string).trim(),
            },
            beforeSend: function() {
                $submitButton.prop('disabled', true);
                $jsAlert.addClass('hidden');
                mainLoaderAnimation = window.lottie.loadAnimation(window.mainLoaderParams);
                $("#registrationModal").addClass('loading');
            }
        })
        .done(function({registered}) {
            if (! registered) {
                return;
            }

            // @ts-ignore
            isProduction() && gtag_report_conversion();

            setTimeout(function() {
                $('#registrationModal').modal('hide');

                // clear form's input after successful registration
                resetInputs();

                $('#confirmationModal').modal('show');

                // always
                $submitButton.prop('disabled', false);
                $("#registrationModal").removeClass('loading');
                mainLoaderAnimation.destroy();
            }, 1000);
        })
        .fail(function(response) {

            setTimeout(() => {
                let errors        = response.responseJSON.errors;
                let firstErrorKey = Object.keys(errors)[0];
                let message       = errors[firstErrorKey][0];

                $sAlert.removeClass('hidden alert-success').addClass('alert-danger');

                $sAlertContent.html(' ');
                $sAlertContent.append(message);

                $(`#${firstErrorKey}`).addClass('is-invalid');

                $form.animate({
                    scrollTop: 0
                }, 500);

                // always
                $submitButton.prop('disabled', false);
                $("#registrationModal").removeClass('loading');
                mainLoaderAnimation.destroy();
            }, 1000);
        });
    }


    /**
     * Reset register form inputs style
     *
     * @return {void}
     */
    function resetInputsLook() {

        $('#registerForm .form-control').each(function (index, input) {
            $(input).removeClass('is-invalid');
        });
    }


    /**
     * Reset register form inputs value
     *
     * @return {void}
     */
    function resetInputs() {

        $form.trigger("reset");
        $speciality.selectpicker("refresh");
        $city.selectpicker("refresh");
    }


    $('#firstname, #lastname, #mobile, #email').on('input', debounce(function (event) {

        event.target.classList[event.target.value ? 'remove' : 'add']('is-invalid');
    }, 300));


    $('#city, #speciality').on('change', debounce(function (event) {

        event.target.value
            ? $(event.target).parents('.bootstrap-select').removeClass('is-invalid')
            : $(event.target).parents('.bootstrap-select').addClass('is-invalid');
    }, 300));


    $mobile.on('blur', function () {

        let _mobile = ($mobile.val() as string).trim();

        if (isPhoneNumber(_mobile)) {
            $mobile.val(internationalize(_mobile));
        }
    });


    $terms.on('change', function (event) {

        let termsAccepted = $(event.target).is(':checked');

        event.target.classList[termsAccepted ? 'remove' : 'add']('is-invalid');
    });

    $privacy.on('change', function (event) {

        let privacyAccepted = $(event.target).is(':checked');

        event.target.classList[privacyAccepted ? 'remove' : 'add']('is-invalid');
    });
});
